import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../config'
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { ComunicationService } from './comunication.service';
// import { async } from '@angular/core/testing';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class UserService {

  url = AppConfig.url_backend
  key = AppConfig.hapikey

  public token;
  static changeEmitted$: any;
  constructor(private http: HttpClient, private comunicacion: ComunicationService, private router:Router) { }

  private emitChangeSource = new Subject<any>();
  changeEmitted$ = this.emitChangeSource.asObservable();
  emitChange(change: any) {
    this.emitChangeSource.next(change);
  }

  registro(data: any): any {
    return this.http.post(this.url + "/user", data);

  }

  checkToken(): Observable<boolean> {
    let rtoken = localStorage.getItem('refreshToken');
    var token2=null;
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
        .set('X-Content-Type-Options', 'nosniff')
        .set('Cross-Origin-Opener-Policy', 'same-origin')
        .set('Access-Control-Allow-Origin', '*')
        .set('Cross-Origin-Opener-Policy', 'same-origin')

    let token = localStorage.getItem('token');
    let mail = localStorage.getItem('email');
    let value;
    let resp:Observable<any>=this.http.post(this.url + 'auth/t', {refreshToken:rtoken,email:mail}, { headers: headers });
    resp.subscribe(
        res => {
            //console.log(res);
            if (res.token) {
                token2 = res.token;
                localStorage.setItem('token',token2);
            }
        },
        err => {
        },
        () =>{
            if (token || token2) {
                this.token = token;
                value = true;
            } else {
                this.token = '';
                value = false
            }
            return value;
        }
    )
    return resp;
  }


  async logout() {
    localStorage.setItem('menuSingoff', '0');
    const token = localStorage.getItem('token');
    //let headers = new HttpHeaders().set('auth', token)
    const response = await fetch(`${this.url}/logout`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        headers: {
          'Content-Type': 'application/json',
          'auth': token
          // 'Content-Type': 'application/x-www-form-urlencoded',
        }
    })

    const resp = await response.json();
    if(resp.code == 200){
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('role');
        localStorage.removeItem('email');
        localStorage.removeItem('usuario'); 
        
    } 
  }

  is_super(): boolean {

    let rol = localStorage.getItem('role')
    //console.log(rol);
    let json_roles = JSON.parse(rol);
    if (!json_roles) {
      this.comunicacion.setSuper(false);
      return false;
    }
    if (json_roles[0].id == 55242819345) {
      this.comunicacion.setSuper(true);
      return true;
    } else if (json_roles[0].id == 55420418327) {
      this.comunicacion.setSuper(true);
      return true;

    } else {
      this.comunicacion.setSuper(false);
      return false;
    }

  }


  getToken() {
    const token = localStorage.getItem('token');
    return token;
  }

  verifyEmail(carObject): Observable<any> {
    return this.http.post(this.url + '/verify/email', carObject);
  }

  verifyToken(object): Observable<any> {
    return this.http.post(this.url + '/verify/token/front', object);
  }

  verifyUser(data:any) :Promise<any>{
    return this.http.post(this.url + '/verify/user', data).toPromise();
  }

  verifyTokenPromesa(data) :Promise<any>  {
    return this.http.post(this.url + '/verify/token/front', data).toPromise();
  }

  changePass(object): Observable<any> {
    return this.http.post(this.url + '/change/password/for/front', object);
  }

  login(email: string, password: string, r: boolean): any {
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
            .set('X-Content-Type-Options', 'nosniff')
            .set('Cross-Origin-Opener-Policy', 'same-origin')
            .set('Access-Control-Allow-Origin', '*');
            
    let data = {
      email: email,
      password: password,
      r:r
    }
    return this.http.post(this.url + "/login", data, {headers:headers});
  }

  isLoggedIn(){
    const token = localStorage.getItem('token')
    const payload = atob(token.split('.')[1]); // decode payload of token
    const parsedPayload = JSON.parse(payload); // convert payload into an Object

    return parsedPayload.exp > Date.now() / 1000; // check if token is expired    
  }

  getUserById(id, token){
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
    .set('X-Content-Type-Options', 'nosniff')
    .set('Cross-Origin-Opener-Policy', 'same-origin')
    .set('Access-Control-Allow-Origin', '*')
    .set('auth', this.getToken());
    return this.http.get(`${this.url}/getUser/${id}`, {headers:headers});
  }

  editUser(data){
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
    .set('X-Content-Type-Options', 'nosniff')
    .set('Cross-Origin-Opener-Policy', 'same-origin')
    .set('Access-Control-Allow-Origin', '*')
    .set('auth', this.getToken());
    return this.http.put(`${this.url}/updateUser`, data , {headers:headers});
  }

  deleteUser(data){
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
    .set('X-Content-Type-Options', 'nosniff')
    .set('Cross-Origin-Opener-Policy', 'same-origin')
    .set('Access-Control-Allow-Origin', '*')
    .set('auth', this.getToken());
    return this.http.put(`${this.url}/deleteUser`, data, {headers:headers});
  }

  recordar(email){
    const data = {
      email:email
    }
    return this.http.post(`${this.url}/recordarme`,data)
  }

  getTokenFacephi(){
    return this.http.get(`${this.url}/facePhi/Auth`);
  }

}